import api from 'api';
import {useGetApi} from 'common/hooks/useGetApi';
import {useModal} from 'common/hooks/useModal';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {ILogFileDescriptor} from 'types/diplomat/logs/LogFileDescriptor';
import {LogViewerDialog} from './LogViewerDialog';
import LogViewRequestDialog from './LogViewRequestDialog';
import {AlertDialog} from 'components/dialogs/AlertDialog';

type Props = {
   onClose: () => void;
};

export const LogsDialog = React.memo(({onClose}: Props) => {
   const {t} = useTranslation();

   const {open, handleClose, handleOpen} = useModal();
   const {open: openViewer, handleOpen: handleOpenViewer} = useModal();

   const [error, setError] = React.useState<String>();
   const options = React.useMemo(
      () => ({
         onSuccess: (files: ILogFileDescriptor[]) => {
            if (!files) {
               setError(t('No Log Files to View'));
            }
            handleOpen();
         },
      }),
      [setError, handleOpen, t]
   );
   const {request, state: logFiles} = useGetApi<ILogFileDescriptor[]>(api.logsNames, options);
   React.useEffect(() => {
      request();
   }, [request]);

   const [logNames, setLogNames] = React.useState<string[]>();
   const handleRequestClose = React.useCallback(
      (names?: string[]) => {
         if (names) {
            setLogNames(names);
            handleOpenViewer();
         }
         handleClose();
      },
      [setLogNames, handleClose, handleOpenViewer]
   );

   return (
      <div>
         {error ? <AlertDialog content={error} onClose={onClose} /> : null}
         {open ? <LogViewRequestDialog onClose={handleRequestClose} files={logFiles!} /> : null}
         {openViewer ? <LogViewerDialog logNames={logNames} onClose={onClose} /> : null}
      </div>
   );
});
